/*
 * NFT Landing Page - Sailing Ships Collection
 * Copyright (C) 2025 jsaif
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program. If not, see <https://www.gnu.org/licenses/>.
 *
 * Original project: https://github.com/s-shemmee/NFT-Portfolio-Landing-Page
 * Original creator: s-shemmee
 */

import "bootstrap-icons/font/bootstrap-icons.css";
import React, { useState, useEffect } from "react";
import "./Hero.css";

export default function Hero() {
  const [modalImg, setModalImg] = useState(null);
  const [showVideo, setShowVideo] = useState(false);

  // Mapping between image alt text and video files
  const videoMap = {
    "01": "Ship01.mp4",
    "02": "Ship02.mp4",
    "03": "Ship03.mp4",
    "04": "Ship04.mp4",
    "05": "Ship05.mp4",
    "06": "Ship06.mp4",
    "07": "Ship07.mp4",
    "08": "Ship08.mp4",
    "09": "Ship09.mp4",
  };

  const openModal = (src, alt) => {
    setModalImg({ src, alt });
    setShowVideo(false);
  };

  const toggleVideo = () => {
    setShowVideo(!showVideo);
  };

  const closeModal = () => {
    setModalImg(null);
    setShowVideo(false);
  };
  // Full scroll locking behavior + Escape key + cleanup (from Team.js)
  useEffect(() => {
    if (modalImg) {
      // Store original overflow values
      const originalDocumentOverflow = document.documentElement.style.overflow;
      const originalBodyOverflow = document.body.style.overflow;

      // Apply overflow hidden to prevent scrolling without position fixed
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
      document.body.classList.add("modal-open");

      const handleEscape = (e) => {
        if (e.key === "Escape") {
          closeModal();
        }
      };
      document.addEventListener("keydown", handleEscape);

      return () => {
        document.body.classList.remove("modal-open");
        // Restore original overflow values
        document.documentElement.style.overflow = originalDocumentOverflow;
        document.body.style.overflow = originalBodyOverflow;
        document.removeEventListener("keydown", handleEscape);
      };
    }
  }, [modalImg]);

  return (
    <section className="hero">
      <div className="container-fluid">
        <div className="content">
          <h1>
            <span>
              collect & sell
              <br />
              super rare nfts
            </span>
          </h1>{" "}
          <div className="container hero-cards-container">
            <div className="hero-cards-grid">
              <div className="hero-card hero-card-1">
                <button
                  onClick={() => openModal(require("../images/Ship01.png"), "01")}
                  className="hero-card-button"
                  title="View Ship01 NFT"
                  aria-label="View Ship01 NFT details"
                >
                  <img className="hero-card-image tertiary-image" src={require("../images/Ship01.png")} alt="01" />
                </button>
                <button
                  onClick={() => openModal(require("../images/Ship08.png"), "08")}
                  className="hero-card-button"
                  title="View Ship08 NFT"
                  aria-label="View Ship08 NFT details"
                >
                  <img className="hero-card-image tertiary-image" src={require("../images/Ship08.png")} alt="08" />
                </button>
              </div>

              <div className="hero-card hero-card-2">
                <button
                  onClick={() => openModal(require("../images/Ship02.png"), "02")}
                  className="hero-card-button"
                  title="View Ship02 NFT"
                  aria-label="View Ship02 NFT details"
                >
                  <img className="hero-card-image tertiary-image" src={require("../images/Ship02.png")} alt="02" />
                </button>
                <button
                  onClick={() => openModal(require("../images/Ship03.png"), "03")}
                  className="hero-card-button"
                  title="View Ship03 NFT"
                  aria-label="View Ship03 NFT details"
                >
                  <img className="hero-card-image tertiary-image" src={require("../images/Ship03.png")} alt="03" />
                </button>
              </div>

              <div className="hero-card hero-card-3 hero-card-main">
                <button
                  onClick={() => openModal(require("../images/Ship04.png"), "04")}
                  className="hero-card-button"
                  title="View Ship04 NFT"
                  aria-label="View Ship04 NFT details"
                >
                  <img className="hero-card-image main-image" src={require("../images/Ship04.png")} alt="04" />
                </button>
              </div>

              <div className="hero-card hero-card-4">
                <button
                  onClick={() => openModal(require("../images/Ship05.png"), "05")}
                  className="hero-card-button"
                  title="View Ship05 NFT"
                  aria-label="View Ship05 NFT details"
                >
                  <img className="hero-card-image tertiary-image" src={require("../images/Ship05.png")} alt="05" />
                </button>
                <button
                  onClick={() => openModal(require("../images/Ship06.png"), "06")}
                  className="hero-card-button"
                  title="View Ship06 NFT"
                  aria-label="View Ship06 NFT details"
                >
                  <img className="hero-card-image tertiary-image" src={require("../images/Ship06.png")} alt="06" />
                </button>
              </div>

              <div className="hero-card hero-card-5">
                <button
                  onClick={() => openModal(require("../images/Ship07.png"), "07")}
                  className="hero-card-button"
                  title="View Ship07 NFT"
                  aria-label="View Ship07 NFT details"
                >
                  <img className="hero-card-image tertiary-image" src={require("../images/Ship07.png")} alt="07" />
                </button>
                <button
                  onClick={() => openModal(require("../images/Ship09.png"), "09")}
                  className="hero-card-button"
                  title="View Ship09 NFT"
                  aria-label="View Ship09 NFT details"
                >
                  <img className="hero-card-image tertiary-image" src={require("../images/Ship09.png")} alt="09" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>{" "}
      {modalImg && (
        <div className="image-modal">
          <button
            className="modal-backdrop-button"
            onClick={closeModal}
            onKeyDown={(e) => {
              if (e.key === "Escape") {
                closeModal();
              }
            }}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "transparent",
              border: "none",
              cursor: "default",
              zIndex: -1,
            }}
            aria-label="Close modal"
            tabIndex={-1}
          />
          <div className="image-modal-content">
            {!showVideo ? (
              <div className="image-container">
                <img src={modalImg.src} alt={modalImg.alt} />
                <button className="close-modal-btn" onClick={closeModal} title="Close">
                  ✕
                </button>
                {videoMap[modalImg.alt] && (
                  <button className="play-video-btn" onClick={toggleVideo} title="Play Video">
                    <i className="bi bi-play-circle-fill"></i> Play Video
                  </button>
                )}
              </div>
            ) : (
              <div className="video-container">
                <video controls autoPlay muted playsInline className="modal-video" onClick={(e) => e.stopPropagation()}>
                  <source src={`${process.env.PUBLIC_URL}/videos/${videoMap[modalImg.alt]}`} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
                <button className="close-modal-btn" onClick={closeModal} title="Close">
                  ✕
                </button>
                <button className="back-to-image-btn" onClick={toggleVideo} title="Back to Image">
                  <i className="bi bi-image-fill"></i> Back to Image
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </section>
  );
}
